import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class StandardActionRatings extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'StandardActionRatings'
  // Define default properties here
  static instanceDefaults () {
    return {
      compassActionId: null,
      rating: null,
      categoryId: null,
      frameworkId: null,
    }
  }
}
const servicePath = 'standard-action-ratings'
const servicePlugin = makeServicePlugin({
  Model: StandardActionRatings,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
